import { CategoryAudit } from "./components/CategoryAudit";

export default CategoryAudit;